<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2 class="mb-2">{{ formData.title }}</h2>
                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <h3>{{ formData.subTitle }}</h3>
                            <p>{{ formData.description }}</p>
                            <TextInput
                                v-model="form.firstName"
                                v-validate="'required'"
                                data-vv-as="Naam"
                                :disabled="processing"
                                :error="errors.first('firstName')"
                                :name="'firstName'"
                                label="Voornaam"
                                placeholder="Voornaam"
                            ></TextInput>
                            <TextInput
                                v-model="form.lastName"
                                v-validate="'required'"
                                data-vv-as="Achternaam"
                                :disabled="processing"
                                :error="errors.first('lastName')"
                                :name="'lastName'"
                                label="Achternaam"
                                placeholder="Achternaam"
                            ></TextInput>
                            <TextInput
                                v-model="form.email"
                                v-validate="{ required: true, email: true }"
                                data-vv-as="E-mail"
                                :disabled="processing"
                                :error="errors.first('email')"
                                :name="'email'"
                                label="E-mailadres"
                                placeholder="naam@provider.com"
                            ></TextInput>
                            <TextInput
                                v-model="form.phoneNumber"
                                v-validate="'required'"
                                data-vv-as="Telefoonnummer"
                                :disabled="processing"
                                :error="errors.first('phoneNumber')"
                                :name="'phoneNumber'"
                                :label="'Telefoonnummer'"
                                :placeholder="'Telefoonnummer'"
                            ></TextInput>

                            <RadioInput
                                v-if="!formData.hideLeerweg"
                                v-model="form.educationDirection"
                                v-validate="'required'"
                                data-vv-as="Leerweg"
                                :options="formData.educationDirectionOptions"
                                :disabled="processing"
                                :error="errors.first('educationDirection')"
                                :name="'educationDirection'"
                                label="Leerweg"
                                placeholder="Leerweg"
                            ></RadioInput>

                            <label class="form-label" for="day">
                                Kies een dag *
                            </label>
                            <select
                                id="day"
                                v-model="form.dayLocation"
                                v-validate="'required'"
                                name="day"
                                data-vv-as="Dag"
                                required
                                class="dropdown-input__input form-input"
                                :class="{
                                    'form-input--error': errors.first('day')
                                }"
                            >
                                <option
                                    v-for="dayLocation in formData.dayLocations"
                                    :key="dayLocation.day"
                                    :value="dayLocation"
                                    >{{ dayLocation.day }}</option
                                >
                            </select>
                            <div
                                class="form-error"
                                :class="{
                                    'form-error--visible': errors.first('day')
                                }"
                            >
                                {{ errors.first('day') }}
                            </div>
                            <template v-if="form.day">
                                <label class="form-label" for="dayLocation">
                                    Kies een locatie *
                                </label>
                                <select
                                    id="dayLocation"
                                    v-model="form.locations"
                                    v-validate="'required'"
                                    name="dayLocation"
                                    data-vv-as="Locatie"
                                    class="dropdown-input__input form-input"
                                    :class="{
                                        'form-input--error': errors.first(
                                            'dayLocation'
                                        )
                                    }"
                                >
                                    <option
                                        v-for="location in form.dayLocation
                                            .locations"
                                        :key="location.location"
                                        :value="location"
                                        >{{ location.location }}</option
                                    >
                                </select>
                            </template>
                            <div
                                class="form-error"
                                :class="{
                                    'form-error--visible': errors.first(
                                        'dayLocation'
                                    )
                                }"
                            >
                                {{ errors.first('dayLocation') }}
                            </div>
                            <div class="col text-center mt-2">
                                <button
                                    class="btn btn-primary mb-1"
                                    :disabled="processing"
                                    @click.prevent="validateAndSubmit"
                                >
                                    Verstuur
                                </button>
                            </div>
                        </form>
                        <div
                            v-else
                            key="successMessage"
                            class="rte"
                            v-html="formData.successMessage"
                        ></div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import RadioInput from '@/components/form/radio-input';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });

export default {
    components: {
        TextInput,
        RadioInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            form: {
                firstName: '',
                lastName: '',
                email: '',
                emailTitleHorizon: '',
                emailHorizon: '',
                subjectHorizon: '',
                descriptionHorizon: '',
                emailTitleSignee: '',
                subjectSignee: '',
                descriptionSignee: '',
                phoneNumber: '',
                educationDirection: 'Onbekend',
                day: '',
                dayLocation: '',
                location: '',
                blockId: this.id
            },
            postUrl: '/api/SignupFormApi/Submit'
        };
    },
    computed: {
        errorMessageFromApi() {
            return this.errorMessage;
        }
    },
    watch: {
        'form.locations': {
            handler: function(value) {
                this.form.location = value.location + '-' + value.mailAddress;
            }
        },
        'form.dayLocation': {
            handler: function(value) {
                this.form.day = value.day;
            }
        }
    },
    mounted() {
        this.form.emailHorizon = this.formData.email;
        this.form.subjectHorizon = this.formData.subjectHorizon;
        this.form.descriptionHorizon = this.formData.descriptionHorizon;
        this.form.subjectSignee = this.formData.subjectSignee;
        this.form.descriptionSignee = this.formData.descriptionSignee;
        this.form.emailTitleSignee = this.formData.emailTitleSignee;
        this.form.emailTitleHorizon = this.formData.emailTitleHorizon;
    }
};
</script>

<style lang="scss"></style>
